export interface ResearcherRole {
  value: string;
  label: string;
}

export const RESEARCHER_ROLES: ResearcherRole[] = [
  { value: 'ResearchPersonnel', label: 'Research Personnel' },
  { value: 'NTRIRBCoordinator', label: 'NTRIRB Coordinator' },
  { value: 'PrincipalInvestigator', label: 'Principal Investigator' }
];

export const RESEARCHER_ROLE_VALUES = {
  RESEARCH_PERSONNEL: 'ResearchPersonnel',
  NTRIRB_COORDINATOR: 'NTRIRBCoordinator',
  PRINCIPAL_INVESTIGATOR: 'PrincipalInvestigator'
} as const;
